import { SUPPORT_FORM_JA_HREF } from 'modules/static-pages/constants';

import styles from './guidelines.module.scss';

const GuidelinesContentJa = () => (
  <div className={styles.wrapper}>
    <div className={styles.box}>
      <div className={styles.icon}>
        <img
          src="https://res.cloudinary.com/zehitomo/image/upload/v1653985864/ok7jiaoxkdn5t54fwt8n.svg"
          alt="icon"
        />
        <div>プロの皆様</div>
      </div>
      <div className={styles.text}>
        <div>
          利用規約を遵守し、モラルのある適切なご利用をお願いいたします。当コミュニテイーの不適切な利用・悪用は固く禁じます。
        </div>
        <div>不適切な内容や公序良俗に反する投稿を禁止いたします。</div>
        <div>全取引を通じて、失礼のないよう丁寧で親切な対応をしましょう。</div>
        <div>
          依頼内容の確認は慎重に行ってください。ご自身のスキルが、確実にクライアントの希望を満たせるものかを事前にご判断の上、依頼を受けるようにしてください。
        </div>
        <div>クライアントからの質問には、あいまいさを残さず、できるだけ明確にご回答ください。</div>
        <div>事前準備を心がけ、約束の時間を必ず守りましょう。</div>
        <div>
          取引開始から当日のお仕事完了まで、ご自身のクライアントに対して責任を持ってご対応ください。
        </div>
        <div>お取引中は、いかなる場合もプロとしてふさわしい態度を守ってください。</div>
        <div>全ユーザーの安全が最優先です。少しでも不安を感じた場合は取引を中止してください。</div>
        <div>
          お困りの際は、
          <a
            className={styles.contact}
            href={SUPPORT_FORM_JA_HREF}
            rel="noopener noreferrer"
            target="_blank"
          >
            お問い合わせフォーム
          </a>
          までご連絡ください。
        </div>
      </div>
    </div>
    <div className={styles.box}>
      <div className={styles.icon}>
        <img
          src="https://res.cloudinary.com/zehitomo/image/upload/v1653985966/qbololh3198rpyxrlcwf.svg"
          alt="icon"
        />
        <div>クライアントの皆様</div>
      </div>
      <div className={styles.text}>
        <div>
          利用規約を遵守し、モラルのある適切なご利用をお願いいたします。当コミュニテイーの不適切な利用・悪用は固く禁じます。
        </div>
        <div>不適切な内容や公序良俗に反する投稿を禁止いたします。</div>
        <div>全取引を通じて、失礼のないよう丁寧で親切な対応をしましょう。</div>
        <div>不適切な理由での依頼や、相手に不快感を与えるような依頼の提出はお控えください。</div>
        <div>プロからの質問には、あいまいさを残さず、できるだけ明確にご回答ください</div>
      </div>
    </div>
  </div>
);

export default GuidelinesContentJa;
